// component
import Iconify from '../Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export const navConfigAdmin =
 [
  {
    title: 'dashboard',
    path: '/dashboard/perfectlayout',
    icon: getIcon('eva:pie-chart-2-fill'  ),
  },
  {
    title: 'analytics',
    path: '/dashboard/analytics',
    icon: getIcon('mdi:land-plots-marker'),
  },
  {
    title: 'Projects',
    path: '/dashboard/projectadmin',
    icon: getIcon('mdi:land-plots-marker'),
  },
  {
    title: 'My Admins',
    icon: getIcon('mdi:users-add'),
    path: '/dashboard/adminUser'
  },
  {
    title: 'All Associate',
    icon: getIcon('clarity:users-solid'),
    path: '/dashboard/adminAgentUser'
  },
  {
    title: 'Procurement Users',
    icon: getIcon('material-symbols:business-center'),
    path: '/dashboard/adminProcurementUser'
  },
  {
    title: 'Procurement Management',
    icon: getIcon('material-symbols:business-center'),
    path: '/dashboard/procurement'
  },
  {
    title: 'Layout Requests',
    icon: getIcon('material-symbols:request-page'),
    path: '/dashboard/layout-requests'
  },
  {
    title: 'Ads',
    path: '/dashboard/ads/create',
    icon: getIcon('mdi:advertisements'),
  },
  {
    title: 'Manage offers',
    icon: getIcon('clarity:users-solid'),
    path: '/dashboard/offers'
  },
  {
    title: 'Customer Offers',
    path: '/dashboard/Customeroffers',
    icon: getIcon('mdi:account-group'),
  },
  {
    title: 'Agent Offers',
    path: '/dashboard/agentoffers',
    icon: getIcon('material-symbols:real-estate-agent-rounded'),
  },
  {
    title: 'Commission (Dont use)',
    path: '/dashboard/commission',
    icon: getIcon('material-symbols:percent'),
  },
  {
    title: 'Bank Details',
    path: '/dashboard/bankdetails',
    icon: getIcon('material-symbols:account-balance'),
  },
  {
    title: 'Posters',
    path: '/dashboard/imgEdit',
    icon: getIcon('icons8:advertising'),
    children: [
      {
        title: 'Posters',
        path:'/dashboard/imgEdit',
      },
      {
        title: 'Visting Cards',
        path: '/dashboard/VisitingPoster',
      },
      {
        title: 'Daily Quotation',
        path:'/dashboard/Quotations',
      },
    ]
    },
    {
      title: 'Payments',
      path: '/dashboard/paymentdetails',
      icon: getIcon('material-symbols:payments-sharp'),
    },
    {
      title: 'Manage Map',
      path: '/dashboard/MapList',
      icon: getIcon('gis:location-poi'),
    },
    {
      title: 'Map',
      path: '/dashboard/Map',
      icon: getIcon('gis:location-poi'),
    },
    {
      title: 'Email Broadcast',
      path: '/dashboard/email-broadcast',
      icon: getIcon('eva:email-fill'),
    },
];

export const navConfigAgent =
 [
  {
    title: 'dashboard',
    path: '/dashboard/perfectlayout',
    icon: getIcon('eva:pie-chart-2-fill'),
  },
  {
    title: 'Projects',
    path: '/dashboard/projectagent',
    icon: getIcon('mdi:land-plots-marker'),
  },
  {
    title: 'My QR',
    icon: getIcon('material-symbols:qr-code-scanner-rounded'),
    path: '/dashboard/Myqr'
  },
  {
    title: 'My Associate',
    icon: getIcon('clarity:users-solid'),
    path: '/dashboard/agentUser'
  },
  {
    title: 'My Approval',
    icon: getIcon('mdi:approval'),
    path: '/dashboard/AgentAprroval'
  },
  // {
  //   title: 'Procurement Management',
  //   icon: getIcon('material-symbols:business-center'),
  //   path: '/dashboard/procurement'
  // },

  {
    title: 'My Wallet',
    icon: getIcon('solar:wallet-bold'),
    path: '/dashboard/wallet'
  },
  {
    title: 'Customer Offers',
    path: '/dashboard/Customeroffers',
    icon: getIcon('mdi:account-group'),
  },
  {
    title: 'Agent Offers',
    path: '/dashboard/agentoffers',
    icon: getIcon('material-symbols:real-estate-agent-rounded'),
  },
  {
    title: 'Commission (Dont use)',
    path: '/dashboard/commission',
    icon: getIcon('material-symbols:percent'),
  },
  {
    title: 'Bank Details',
    path: '/dashboard/bankdetails',
    icon: getIcon('material-symbols:account-balance'),
  },
  {
    title: 'Posters',
    path: '/dashboard/imgEdit',
    icon: getIcon('icons8:advertising'),
    children: [
      {
        title: 'Posters',
        path:'/dashboard/imgEdit',
      },
      {
        title: 'Visting Cards',
        path: '/dashboard/VisitingPoster',
      },
      {
        title: 'Daily Quotation',
        path:'/dashboard/Quotations',
      },
    ]
    },
    {
      title: 'Payments',
      path: '/dashboard/paymentdetails',
      icon: getIcon('material-symbols:payments-sharp'),
    },
    {
      title: 'Map',
      path: '/dashboard/Map',
      icon: getIcon('gis:location-poi'),
    },
];


export const navConfigProp =
 [
  {
    title: 'dashboard',
    path: '/dashboard/procurement-dashboard',
    icon: getIcon('eva:pie-chart-2-fill'),
  },
  {
    title: 'Projects',
    path: '/dashboard/projectadmin',
    icon: getIcon('mdi:land-plots-marker'),
  },
  {
    title: 'Procurement Management',
    icon: getIcon('material-symbols:business-center'),
    path: '/dashboard/procurement'
  },
  {
    title: 'Layout Management',
    icon: getIcon('material-symbols:view-quilt'),
    path: '/dashboard/layout-requests'
  },
  {
    title: 'Layout View',
    path: '/dashboard/procurement/layout-requests',
    icon: getIcon('material-symbols:request-page'),
  },
  {
    title: 'Ads',
    path: '/dashboard/procurement/ads-requests',
    icon: getIcon('mdi:advertisements'),
  },
  {
    title: 'Payment Requests',
    path: '/dashboard/payment-requests',
    icon: getIcon('material-symbols:payments-sharp'),
  },
  // {
  //   title: 'My Associate',
  //   icon: getIcon('clarity:users-solid'),
  //   path: '/dashboard/agentUser'
  // },
  // {
  //   title: 'My Wallet',
  //   icon: getIcon('solar:wallet-bold'),
  //   path: '/dashboard/wallet'
  // },
  {
    title: 'Customer Offers',
    path: '/dashboard/Customeroffers',
    icon: getIcon('mdi:account-group'),
  },
  {
    title: 'Agent Offers',
    path: '/dashboard/agentoffers',
    icon: getIcon('material-symbols:real-estate-agent-rounded'),
  },
  // {
  //   title: 'Commission (Dont use)',
  //   path: '/dashboard/commission',
  //   icon: getIcon('material-symbols:real-estate-agent-rounded'),
  // },
  {
    title: 'Bank Details',
    path: '/dashboard/bankdetails',
    icon: getIcon('material-symbols:account-balance'),
  },
  {
    title: 'Posters',
    path: '/dashboard/imgEdit',
    icon: getIcon('icons8:advertising'),
    children: [
      {
        title: 'Posters',
        path:'/dashboard/imgEdit',
      },
      {
        title: 'Visting Cards',
        path: '/dashboard/VisitingPoster',
      },
      {
        title: 'Daily Quotation',
        path:'/dashboard/Quotations',
      },
    ]
    },
    // {
    //   title: 'Payments',
    //   path: '/dashboard/paymentdetails',
    //   icon: getIcon('material-symbols:payments-sharp'),
    // },
    {
      title: 'Map',
      path: '/dashboard/Map',
      icon: getIcon('gis:location-poi'),
    },
];